import { takeLatest, all, call, put } from 'redux-saga/effects';

import apis from '../apis/chat';

import {
  types,
  rejectTutorSuccess,
  rejectTutorFailed,
} from '../redux/rejectTutor';
import { updateSelectQuestion } from '../redux/selectQuestion';

function* rejectUserFlow(action) {
  const { userID, QID } = action.payload;

  try {
    const response = yield call(apis.rejectTutor, userID, QID);

    const {
      data: { question },
    } = response;

    // signify reject tutor success
    yield put(rejectTutorSuccess());

    // update selected question in chat.
    yield put(updateSelectQuestion(question));
  } catch (err) {
    yield put(rejectTutorFailed(err));
  }
}

export default function* () {
  yield all([takeLatest(types.REJECT_TUTOR, rejectUserFlow)]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/rejectTutor.js